import { z } from "zod";

import { DEFAULT_STATUS, STATUS_LABELS, STATUS_OPTIONS } from "../../../../utils/statusFilter";

export { STATUS_LABELS, STATUS_OPTIONS };

export const ROLES_PAGE_SIZE = 25;

export interface RolesFilters {
	status: "active" | "archived" | "any";
}

export const DEFAULT_FILTERS: RolesFilters = { status: DEFAULT_STATUS };

export const RolesFilterFormSchema = z.object({
	status: z.enum(["active", "archived", "any"]),
});

export type RolesFilterForm = z.infer<typeof RolesFilterFormSchema>;
